import { BodyText, Flex_unstable as Flex, Heading } from '@farol-ds/react'

import styles from './variant-a.module.scss'

export interface VariantAProps {
  title: string
  description: string
  searchParam: string
  buttonContent: React.ReactNode
}

export function VariantA({ title, description, searchParam, buttonContent }: VariantAProps) {
  return (
    <Flex direction="column" gap="3xs" align="center">
      <Flex direction="column" align="center" gap="6xs" className={styles.textBlock}>
        <Heading size="md">{title}</Heading>
        <BodyText size="md">
          {description} <span className={styles.searchParam}>{searchParam}</span>
        </BodyText>
      </Flex>
      <Flex justify="center" className={styles.buttonContainer}>
        {buttonContent}
      </Flex>
    </Flex>
  )
}
